import {getToken} from "../Utils/Common";

let url = process.env.REACT_APP_BACKEND_API_URI
let analyse_handler_url = process.env.REACT_APP_BASE_URI

export async function createAnnotation(lvID, ID, rowID, annotation, positionText) {
    console.log(lvID)
    return fetch(`${url}annotator/create_annotation`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            "token": getToken(),
            "lv_id": lvID,
            "rowId": rowID,
            "annotation": annotation,
            "unique_id": ID,
            "positionText": positionText
        })
    })
        .then(function (response) {
            return response.json();
        }).then(function (myJson) {
            return myJson;
        })
        .catch((error) => {
            console.log(error)
        });
}

export async function removeAnnotation(lvID, unique_id, rowId, pText) {

    return fetch(`${url}annotator/delete_annotation`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            "token": getToken(),
            "lv_id": lvID,
            "unique_id": unique_id,
            "rowId": rowId,
            "pText": pText
        })
    }).then(response => response.json())
        .then((data) => {
            if (!data.response) {
                console.log(data.response)
            }
        })
        .catch((error) => {
            console.log(error)
        });
}

export async function getCurrentAnalyse(lvID, combine_chunks= false) {

    return fetch(`${url}annotator/resume_analyse`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({"lv_id": lvID, "combine_chunks": combine_chunks, "token": getToken()})
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });

}

export function getSimpleSearch(query, category, industry, cat_exclude, hinweis_only, completed_only) {
    console.log(category, industry)
    return fetch(`${url}annotator/simple_search`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            "token": getToken(),
            "query": query,
            "category": category,
            "industry": industry,
            "cat_exclude": cat_exclude,
            "hinweis_only": hinweis_only,
            "completed_only": completed_only,
            "type": "test"})
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });

}

export async function getSearch(jobID) {

    return fetch(`${url}annotator/retrieve_search`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({"token": getToken(), "job_id": jobID})
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });

}

export async function fetchData(jobId, pageItemOffset = 0, pageSize = 10) {
    return fetch(`${analyse_handler_url}/fetch_data`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            // token: getToken(),
            job_id: jobId,
            item_offset: pageItemOffset,
            page_size: pageSize
        })
    }).then(resp => resp.json())
        .catch((error) => {
        console.error(error);
    });
}

export async function getJobs() {

    return fetch(`${url}annotator/jobs`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({"token":getToken(),"met":"GET"})
    }).then(response => response.json())
        .catch((error) => {
            alert(error)
            console.error('Error:', error);
        });

}

export async function deleteJob(job_id) {

    return fetch(`${url}annotator/delete_job`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({"token":getToken(),"job_id": job_id})
    }).then(response => response.json())
        .catch((error) => {
            alert(error)
            console.error('Error:', error);
        });

}


export async function getAdvanceSearch(query, start, end, category, industry, cat_exclude, hinweis_only, completed_only) {

    return fetch(`${url}annotator/advanced_search`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({"token": getToken(),
            "query": query,
            "start": start,
            "end": end,
            "category": category,
            "industry": industry,
            "cat_exclude": cat_exclude,
            "hinweis_only": hinweis_only,
            "completed_only": completed_only})

    }).then(response => response)
        .catch((error) => {
            alert(error)
            console.error('Error:', error);
        });

}

export async function writeInitialData(lvID, annotations, document) {

    return fetch(`${process.env.REACT_APP_BASE_URI}/write_to_annotator`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({"lv_id": lvID, "annotations": annotations, "lvDocument": document})
    }).then(response => response.status)
        .catch((error) => {
            console.error('Error:', error);
        });
}

export async function retrieveMatches(inputs, hash) {

    return fetch(`${url}annotator/retrieve_matched_documents`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({"inputs": inputs, "hash":hash, "token": getToken()})
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });

}

export function updateAnnotations(inputs) {
    inputs.token = getToken()
    return fetch(`${url}annotator/update_annotations`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(inputs)
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });

}

export async function getAnnotations(rowId) {

    return fetch(`${url}annotator/get_annotations`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({"rowId": rowId, "token":getToken()})
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });

}

export async function fetchAiTags() {
    return fetch(`${url}annotator/fetch_ai_tags`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({"token":getToken(),"met":"GET"})
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}

export async function fetchCatAttributeStats() {
    return fetch(`${url}annotator/fetch_cat_attribute_stats`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({"token":getToken(),"met":"GET"})
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}

export async function addCategoryAttribute(category, aiTag, name, description) {

    const data = {"category": category, "AI_tag": aiTag, "name": name, "description": description}

    return fetch(`${url}annotator/add_category_attribute`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({'data': data, 'token': getToken() })
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}

export async function addCategoryEinheits(category, einheits, name, description) {

    const data = {"category": category, "units": einheits, "name": name, "description": description}

    return fetch(`${url}annotator/add_category_units`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({'data': data, 'token': getToken() })
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}

export async function updateAnnotationRuleset(ruleset) {
    return fetch(`${url}annotator/update_ruleset`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({'data': ruleset, 'token': getToken() })
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}

export async function fetchAnnotationRuleset() {
    return fetch(`${url}annotator/fetch_ruleset`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({'token': getToken() })
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error: ', error);
        });
}

export async function removeCategoryAttribute(stat_id, attr_id) {

    return fetch(`${url}annotator/remove_category_attribute`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({'stat_id': stat_id, 'attr_id': attr_id, 'token': getToken() })
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}

export async function updateCategoryAttribute(risksItem) {
    return fetch(`${url}annotator/update_category_attribute`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({'updatedItem': risksItem, 'token': getToken() })
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}

export async function updateCategoryUnits(risksItem) {
    return fetch(`${url}annotator/update_category_units`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({'updatedItem': risksItem, 'token': getToken() })
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}


export async function create_prompt(question, category, advice) {
    return fetch(`${url}annotator/create_prompt`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            "token": getToken(),
            "question": question,
            "category": category,
            "advice": advice
        })
    })
        .then(function (response) {
            return response.json();
        }).then(function (myJson) {
            return myJson;
        })
        .catch((error) => {
            console.log(error)
        });
}

export async function getAllPrompts() {

    return fetch(`${url}annotator/fetch_all_prompts`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({"token":getToken(),"met":"GET"})
    }).then(response => response.json())
        .catch((error) => {
            alert(error)
            console.error('Error:', error);
        });
}

// Delete one advice from the advices catalogue
export function deletePrompt(prompt_id) {

    let link = url + "annotator/delete_prompt/"+prompt_id


    return fetch(link, {
        method: 'POST',
        headers: {
            //'Authorization': getToken(),
            "Content-Type": "application/json"
        },
        body:JSON.stringify({"token":getToken(),"del":"del"})
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}